import RootLayout from "@/layouts/RootLayout";
import {
  ErrorFallback,
  OptimizationUtils,
  SuspenseWrapper,
} from "@crescentapplications/react-ui";
import type { RouteObject } from "react-router";

const { lazyWithRetry } = OptimizationUtils;

const AboutAhmad = lazyWithRetry(() => import("@/pages/AboutAhmad"));
const NotFound = lazyWithRetry(() => import("@/pages/NotFound"));

const publicRoutesChildren: RouteObject[] = [
  {
    index: true,
    element: (
      <SuspenseWrapper>
        <AboutAhmad />
      </SuspenseWrapper>
    ),
  },
  {
    path: "*",
    element: (
      <SuspenseWrapper>
        <NotFound />
      </SuspenseWrapper>
    ),
  },
];

const routes: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorFallback />,
    element: <RootLayout />,
    children: publicRoutesChildren,
  },
];

export default routes;
